import { createSurfaceColumn, surfaceColumnFromSample } from './surface.js';
import { groundFertility, hasLivingGround } from './habitat.js';
import type { PlanetSampler, TerrainSample } from './universe.js';
import { wildlifePlanet, type WildlifeFrame, type WildlifeVec } from './wildlife.js';
export interface WildlifeGround { y:number; safe:boolean; forage:number; freshwater:boolean }
/** Fixed-frame height query. Solve along the frame's up axis, rather than
 * treating a radial height as tangent-plane height on the curved planet. */
export function wildlifeGround(sampler:PlanetSampler, frame:WildlifeFrame, x:number,z:number):WildlifeGround {
  const sample={} as TerrainSample, col=createSurfaceColumn(); let y=0;
  for(let i=0;i<3;i++) {
    const p=wildlifePlanet(frame,x,y,z),r=Math.hypot(...p),u=p.map(v=>v/r) as WildlifeVec;
    sampler.sample(...u,sample,true);
    surfaceColumnFromSample(sampler.def,sampler.amplitude,sample,col);
    y+=(col.supportR-r)/Math.max(.5,u.reduce((s,v,k)=>s+v*frame.up[k],0));
  }
  const forage=groundFertility(sample.temp,sample.moist)*(1-Math.min(1,sample.duneSand??0))*(1-Math.min(1,sample.canyonRock??0));
  return {y,forage,safe:hasLivingGround(sampler.def)&&sample.temp>-.45&&sample.temp<.65
    &&col.supportMaterial==='terrain'&&col.liquid!=='lava'&&col.waterDepth<.16&&(sample.town??0)<.05,
    freshwater:col.waterDepth>=-.08&&col.waterDepth<=.16&&col.waterR>(sampler.def.seaRadius??-1e9)+.3
      &&(col.riverK>.1||(sample.wetlandMask??0)>.1)};
}
